import { render, staticRenderFns } from "./AddDependentForm.vue?vue&type=template&id=6d55cda6&scoped=true&"
import script from "./AddDependentForm.vue?vue&type=script&lang=js&"
export * from "./AddDependentForm.vue?vue&type=script&lang=js&"
import style0 from "./AddDependentForm.vue?vue&type=style&index=0&id=6d55cda6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d55cda6",
  null
  
)

export default component.exports